import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { MouseEvents } from "../../../componets3D/MouseEvents";
import { CameraController } from "../../../componets3D/CameraController";
// import { Floor } from "../objects/Floor";
import { CharcterOxxo } from "../../objects/CharacterOxxo";
import ObserverEmitter, { EVENTS } from "../../../../emitter/Observer";
import { OxxoMap } from "../../objects/Tema1/subtopicSix/OxxoMap";
import { audiosAssets } from "../../../../assets/audio";

export class SceneTopicSix extends Scene {
	constructor(loadingManager, container, render, characterSelected = new CharcterOxxo(), enviroment) {
		super();
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.environment = enviroment;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.characterSelected = characterSelected;
		this.stepActive = 0;
		this.light();
		this.create();
		// this.helper();
		this.renderAnimations();
		this.observerListeners();
	}
	create() {
		this.mapmenu = new OxxoMap(this.loadingManager);
		this.add(this.mapmenu);
		this.add(this.characterSelected);
		// this.floor = new Floor(this.loadingManager);
		// this.add(this.floor);
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	sceneactivityOneSctate() {
		this.mapmenu.onAnimate();
		this.characterSelected.onAnimateSaludo();
		this.characterSelected.visible = true;
		this.characterSelected.position.set(-12.0468, -0.9809, 2.6906);
		this.characterSelected.rotation.set(0, -0.2915, 0);
		// this.characterSelected.helpers()
		this.mouseEvents.disposeInteractions();
		this.mouseEvents.objectsToValue = [
			this.mapmenu.Letrero_caja,
			this.mapmenu.Copete_coca,
			this.mapmenu.Letrero_fastFood,
			this.mapmenu.Letrero_cuartoFrio2,
			this.mapmenu.Letreros1,
			this.mapmenu.Copete_dulces,
			this.mapmenu.Letrero_puerta,
		];
		this.mouseListenersEnableMovementActivityOne();
		// this.mouseListenersEnableMovementActivityone();
	}

	mouseListenersEnableMovementActivityOne() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				const name = interactions[0].object.name;
				ObserverEmitter.emit(EVENTS.subtopicSix.activityOne.clickedRayCaster, name);
				ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoInformacion)
			}
		});
	}

	activeAudio() {
		ObserverEmitter.emit(EVENTS.audioInitByTopic)
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.camera.moveCameraToPoint(new Vector3(-10.9786, -0.2836, -2.208), 1, new Vector3(-10.005, -0.371, -1.869), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
					this.activeAudio()
				});
				break;
			case 1:
				// posicion escritorio 2
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.moveCameraToPoint(new Vector3(-12.4673, -0.6294, 3.969), 1, new Vector3(-11.756, -1.056, 1.086), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					// this.camera.control.maxAzimuthAngle = 1.77;
					// this.camera.control.minAzimuthAngle = 0.976;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.sceneactivityOneSctate();
					this.activeAudio()
				});
				break;

			default:
				this.camera.control.maxAzimuthAngle = Infinity;
				this.camera.control.minAzimuthAngle = Infinity;
				this.camera.moveCameraToPoint(new Vector3(-12.5158, -0.2328, -1.8734), 1, new Vector3(-11.493, -0.366, -1.905), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;

					this.characterSelected.visible = false
					this.activeAudio()
				});
				break;
		}
	}

	observerListeners() {
		ObserverEmitter.on(EVENTS.subtopicSix.activityOne.stepUseRayCaster, (step) => {
			this.stepActive = step;
		});

		ObserverEmitter.on(EVENTS.subtopicSix.activityOne.moveBannerCheckout, () => {
			this.mapmenu.onAnimate(this.mapmenu.Letrero_caja);
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-10.2024, -0.6911, -5.1428), 1, new Vector3(-13.206, -0.33, -4.429), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 2.162;
				this.camera.control.minAzimuthAngle = 1.528;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});
		ObserverEmitter.on(EVENTS.subtopicSix.activityOne.moveBannerCocacola, () => {
			this.mapmenu.onAnimate(this.mapmenu.Copete_coca);
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-9.2516, 0.1184, 3.4619), 1, new Vector3(-6.228, -0.45, 3.019), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = -0.7;
				this.camera.control.minAzimuthAngle = -1.406;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.subtopicSix.activityOne.moveBannerFastFood, () => {
			this.mapmenu.onAnimate(this.mapmenu.Letrero_fastFood);
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-9.1791, -0.2823, -5.0421), 1, new Vector3(-9.797, -0.336, -8.088), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 0.812;
				this.camera.control.minAzimuthAngle = -0.71;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.subtopicSix.activityOne.moveBannerColdRoom, () => {
			this.mapmenu.onAnimate(this.mapmenu.Letrero_cuartoFrio2);
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-0.2267, -0.7043, -0.516), 1, new Vector3(2.877, -0.644, -0.668), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = -1.338;
				this.camera.control.minAzimuthAngle = -1.705;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.subtopicSix.activityOne.moveBannerSide, () => {
			this.mapmenu.onAnimate(this.mapmenu.Letreros1);
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(3.8152, 0.3905, 6.9013), 1, new Vector3(3.658, 0.177, 9.998), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = -1.231;
				this.camera.control.minAzimuthAngle = -3.85;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.subtopicSix.activityOne.moveBannerCopeteHeader, () => {
			this.mapmenu.onAnimate(this.mapmenu.Copete_dulces);
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(0.3444, 0.7485, 10.2322), 1, new Vector3(-0.655, 0.556, 7.296), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = 0.772;
				this.camera.control.minAzimuthAngle = -1.149;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});

		ObserverEmitter.on(EVENTS.subtopicSix.activityOne.moveBannerEntry, () => {
			this.mapmenu.onAnimate(this.mapmenu.Letrero_puerta);
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-6.3291, -0.8996, 2.913), 1, new Vector3(-8.736, -0.616, 4.858), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.enableRotate = false;
				this.camera.control.maxAzimuthAngle = -3.082;
				this.camera.control.minAzimuthAngle = 1.594;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
			});
		});
	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	renderAnimations(delta) { }
}
